// extracted by mini-css-extract-plugin
module.exports = {"d2xZ5":"Z5_d2xZ5__MOnPC"};